import React, { useState, useEffect } from "react";
import { AiOutlineRight } from "react-icons/ai";
import { MdOutlineArrowOutward } from "react-icons/md";
import { Link } from "react-router-dom";

const ConnectSlide = () => {
	const [currentIndex, setCurrentIndex] = useState(0);
	const [visibleCount, setVisibleCount] = useState(3); // Default to 3 cards

	const cards = [
		{
			title: "Access to Essential Care",
			description:
				"We ensure that patients from under-served communities and the middle class are connected to healthcare providers who can offer the care they need without barriers.",
			bgColor: "bg-[#45E99E]", // Green background
		},
		{
			title: "Streamlined Referral Process",
			description:
				"We work with trusted healthcare professionals and clinics to streamline the referral process, ensuring that patients receive timely and appropriate care.",
			bgColor: "bg-[#DFFBEE]", // Light green background
		},
		{
			title: "Personalized Support",
			description:
				"Our foundation focuses on each patient's unique needs, ensuring they receive the right care and ongoing support, every step of the way.",
			bgColor: "bg-[#FFEAC8]", // Peach background
		},
		{
			title: "Building Partnerships",
			description:
				"By partnering with healthcare providers, we expand access to affordable, quality care for those who need it most",
			bgColor: "bg-[#F9DFDD]",
		},
	];

	const handleNext = () => {
		setCurrentIndex((prevIndex) => (prevIndex + 1) % cards.length);
	};

	// Update visible card count based on screen size
	useEffect(() => {
		const handleResize = () => {
			if (window.innerWidth < 640) {
				setVisibleCount(1); // Show 1 card for small screens
			} else if (window.innerWidth < 1024) {
				setVisibleCount(2); // Show 2 cards for medium screens
			} else {
				setVisibleCount(3); // Show 3 cards for large screens
			}
		};

		// Add event listener
		window.addEventListener("resize", handleResize);

		// Set the initial value on component mount
		handleResize();

		// Cleanup listener on component unmount
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	// Get visible cards based on visibleCount
	const visibleCards = Array.from(
		{ length: visibleCount },
		(_, index) => cards[(currentIndex + index) % cards.length]
	);

	return (
		<section className='max-w-[1440px] w-[90%] mx-auto py-8 relative'>
			<h2 className='text-3xl lg:text-6xl text-black font-semibold mb-8'>
				How We Connect You to Care
			</h2>
			<ul
				className={`sm:grid hidden gap-6 relative ${
					visibleCount === 1
						? "grid-cols-1"
						: visibleCount === 2
						? "grid-cols-2"
						: "grid-cols-3"
				} items-end`}>
				{visibleCards.map((card, index) => (
					<li
						key={index}
						className={`${card.bgColor} ${
							index === visibleCount - 1 ? "h-full" : "h-full"
						} 
                        rounded-[30px] p-6 flex flex-col gap-9 text-[#025788]`}>
						<h3 className='text-[32px]/[42px]  font-medium text-[#025788] w-[70%]'>
							{card.title}
						</h3>
						<p className='text-lg/6 text-[#025788]'>{card.description}</p>
					</li>
				))}

				<li>
					<button
						onClick={handleNext}
						className='absolute right-[-2%] bottom-[30%] bg-black text-white w-12 h-12 flex items-center justify-center rounded-full hover:bg-gray-800 transition'>
						<AiOutlineRight size={24} />
					</button>
				</li>
			</ul>

			<ul className='sm:hidden flex flex-col items-center justify-center gap-y-9'>
				{cards.map((card, index) => (
					<li
						key={index}
						className={`${card.bgColor} rounded-[30px] p-6 flex flex-col gap-9`}>
						<h3 className='text-3xl/10 font-semibold text-[#025788] '>
							{card.title}
						</h3>
						<p className='text-sm/5 text-[#025788]'>{card.description}</p>
					</li>
				))}
			</ul>
			<Link
				to='/services'
				className='md:text-2xl lg:mt-0 mt-4 text-lg text-[#15A359] font-normal leading-relaxed flex items-center w-fit gap-x-1 hover:underline decoration-[#15A359] underline-offset-4 decoration-2'>
				<span>Learn more</span>
				<MdOutlineArrowOutward />
			</Link>
		</section>
	);
};

export default ConnectSlide;
